/**
 * Utilitarios de imagem sem dependencia do decodificador. Ficam separados do
 * `useScanner` porque a biblioteca de leitura de codigo pesa mais que o resto
 * do app: telas que so precisam converter uma foto (o cadastro de produto, por
 * exemplo) nao devem arrastar o ZXing para o pacote inicial.
 */

/** Lado maior da foto enviada para a IA — acima disso so encarece o upload. */
export const PHOTO_MAX_SIDE = 1600;

export function frameToDataUrl(
  source: CanvasImageSource,
  width: number,
  height: number,
): string | null {
  const scale = Math.min(1, PHOTO_MAX_SIDE / Math.max(width, height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(width * scale);
  canvas.height = Math.round(height * scale);
  const context = canvas.getContext('2d');
  if (!context) return null;
  context.drawImage(source, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL('image/jpeg', 0.82);
}

/** Converte o arquivo escolhido pelo usuario em JPEG do mesmo tamanho maximo. */
export async function fileToDataUrl(file: File): Promise<string | null> {
  const url = URL.createObjectURL(file);
  try {
    const image = await loadImage(url);
    return frameToDataUrl(image, image.naturalWidth, image.naturalHeight);
  } catch {
    return null;
  } finally {
    URL.revokeObjectURL(url);
  }
}

function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('imagem invalida'));
    image.src = url;
  });
}
